import { createApi } from "@archinventory/client";

/** Same origin as the Worker: cookies just work, no CORS. */
export const api = createApi({ baseUrl: window.location.origin });
export { ApiError, qk, unwrap } from "@archinventory/client";
